var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":"/","width":"100%","height":"1000px","frameborder":"0","_onload":"this.style.height = this.contentWindow.document.documentElement.scrollHeight + 'px'"}})}
var staticRenderFns = []

export { render, staticRenderFns }